import React from 'react';
import { Switch, Route, NavLink, Redirect } from 'react-router-dom';
import Page from '../../components/Page';
import { useIsAdmin, useIsLimitedAdmin } from '../../components/Hooks';

import Script from './footprint';
import Phones from './phones';
import IdlePhones from './idlePhones';
import SandboxPhones from './sandbox';
import Bawa from './bawa';
import Logs from './logs';
import Generate from './generatelink';
import Instagrams from './instagram';
import Subs from './subs_table';
import CartLogs from './cartLogs';
import CartLogDetails from './cartLogDetails';
import CheckoutError from './checkouterror';
import Num from './num';
import FeedBack from './Feedback';
import PhoneEvents from './phoneEvents';
import PausedSubs from './pausedSubs';
import MissedPhones from './missedPhones';
import Screens from './screens';
import SeqPage from './seq';
import LogoutTracking from './logoutTracking';
import SettingsIcon from '@mui/icons-material/Settings';
import PhoneIcon from '@mui/icons-material/Phone';
import InstagramIcon from '@mui/icons-material/Instagram';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import TableViewIcon from '@mui/icons-material/TableView';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import MenuIcon from '@mui/icons-material/Menu';
import FeedbackIcon from '@mui/icons-material/Feedback';
import { Paper, Tab, Tabs, Typography } from '@mui/material';

function AdminHome() {
	return (
		<Paper elevation={24} className="mytp-dashboard">
			<Typography sx={{ padding: '15px' }}>Admin Home</Typography>
			<Generate></Generate>
		</Paper>
	);
}

export default () => {
	const isAdmin = useIsAdmin();
	const isLimitedAdmin = useIsLimitedAdmin();
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	if (!isAdmin) return <Redirect to="/" />;
	return (
		<Page title="Admin" icon={<SettingsIcon />}>
			<Page.Wrap>
				{isLimitedAdmin ? (
					<Tabs className="settings">
						<Tab value="0" className="Tab-css" iconPosition="start" icon={<MenuIcon />} label="Menu" as={NavLink} to="/yta" />
						<Tab value="1" className="Tab-css" iconPosition="start" icon={<SettingsIcon />} label="Footprint" as={NavLink} to="/yta/footprint" />
						<Tab value="2" className="Tab-css" iconPosition="start" icon={<PriorityHighIcon />} label="Feedback" as={NavLink} to="/yta/feedback" />
					</Tabs>
				) : (
					<>
						<Tabs value={value} onChange={handleChange} aria-label="icon tabs example" sx={{ overflow: 'auto' }} variant="scrollable">
							<Tab value="0" label="Menu" as={NavLink} to="/yta" iconPosition="start" className="Tab-css" icon={<MenuIcon />} />
							<Tab value="13" label="CartLogs" as={NavLink} to="/yta/cartlogs" iconPosition="start" className="Tab-css" icon={<SettingsIcon />} />
							<Tab value="12" label="Screens" as={NavLink} to="/yta/screens" iconPosition="start" className="Tab-css" icon={<SettingsIcon />} />
							<Tab
								value="1"
								label="Footprint"
								as={NavLink}
								to="/yta/footprint"
								iconPosition="start"
								className="Tab-css"
								icon={<SettingsIcon />}
							/>
							<Tab value="17" className="Tab-css" iconPosition="start" icon={<PhoneIcon />} label="Paused Subs" as={NavLink} to="/yta/pausedsubs" />

							<Tab value="2" className="Tab-css" iconPosition="start" icon={<PhoneIcon />} label="Phones" as={NavLink} to="/yta/phones" />
							<Tab
								value="9"
								className="Tab-css"
								iconPosition="start"
								icon={<PhoneIcon />}
								label="Idle Phones"
								as={NavLink}
								to="/yta/idlephones"
							/>
							<Tab
								value="11"
								className="Tab-css"
								iconPosition="start"
								icon={<PhoneIcon />}
								label="Sandbox Phones"
								as={NavLink}
								to="/yta/sandboxphones"
							/>
							<Tab
								value="10"
								className="Tab-css"
								iconPosition="start"
								icon={<PhoneIcon />}
								label="Missed Phones"
								as={NavLink}
								to="/yta/missedphones"
							/>
							<Tab value="19" className="Tab-css" iconPosition="start" icon={<PhoneIcon />} label="Bawa" as={NavLink} to="/yta/bawa" />
							<Tab
								value="3"
								className="Tab-css"
								iconPosition="start"
								icon={<PermPhoneMsgIcon />}
								label="Phones Events"
								as={NavLink}
								to="/yta/phonesevents"
							/>
							<Tab
								value="4"
								className="Tab-css"
								iconPosition="start"
								icon={<InstagramIcon />}
								label="Instagrams"
								as={NavLink}
								to="/yta/instagrams"
							/>
							<Tab
								value="5"
								className="Tab-css"
								iconPosition="start"
								icon={<FormatListNumberedIcon />}
								label="Numbers"
								as={NavLink}
								to="/yta/numbers"
							/>
							<Tab
								value="6"
								className="Tab-css"
								iconPosition="start"
								icon={<TableViewIcon />}
								label="Subs Table"
								as={NavLink}
								to="/yta/substable"
							/>
							<Tab
								value="7"
								className="Tab-css"
								iconPosition="start"
								icon={<PriorityHighIcon />}
								label="Checkout Error"
								as={NavLink}
								to="/yta/checkouterror"
							/>
							<Tab value="8" className="Tab-css" iconPosition="start" icon={<FeedbackIcon />} label="Feedback" as={NavLink} to="/yta/feedback" />
							<Tab value="18" className="Tab-css" iconPosition="start" icon={<ManageSearchIcon />} label="Seq" as={NavLink} to="/yta/seq" />
							<Tab value="20" className="Tab-css" iconPosition="start" icon={<PhoneIcon />} label="Logout Takip" as={NavLink} to="/yta/logouttracking" />
						</Tabs>
					</>
				)}
				{isLimitedAdmin ? (
					<Switch>
						<Route path="/yta" exact component={AdminHome} />
						<Route path="/yta/footprint" component={Script} />
						<Route path="/yta/feedback" component={FeedBack} />
						<Redirect to="/yta" />
					</Switch>
				) : (
					<Switch>
						<Route path="/yta" exact component={AdminHome} />
						<Route path="/yta/footprint" component={Script} />
						<Route path="/yta/pausedsubs" component={PausedSubs} />
						<Route path="/yta/phones" component={Phones} />
						<Route path="/yta/cartlogs" component={CartLogs} />
						<Route path="/yta/cartlogdetails" component={CartLogDetails} />
						<Route path="/yta/idlephones" component={IdlePhones} />
						<Route path="/yta/sandboxphones" component={SandboxPhones} />
						<Route path="/yta/bawa" component={Bawa} />
						<Route path="/yta/phonesevents" component={PhoneEvents} />
						<Route path="/yta/instagrams" component={Instagrams} />
						<Route path="/yta/missedphones" component={MissedPhones} />
						{/* <Route path="/yta/numbers" component={Numbers} /> */}
						<Route path="/yta/substable" component={Subs} />
						<Route path="/yta/logs" component={Logs} />
						<Route path="/yta/numbers" component={Num} />
						<Route path="/yta/checkouterror" component={CheckoutError} />
						<Route path="/yta/feedback" component={FeedBack} />
						<Route path="/yta/screens" component={Screens} />
						<Route path="/yta/seq" component={SeqPage} />
						<Route path="/yta/logouttracking" component={LogoutTracking} />
						<Redirect to="/yta" />
					</Switch>
				)}
			</Page.Wrap>
		</Page>
	);
};
